<form [errorMessage]="errorMessage" [formGroup]="vm" class="common-form" [simpleMode]="isSimpleMode">
    <ng-container *ngIf="selectType === SnapSourceSelectTypeE.Multi">
        <!-- 已选FS区域collaps，极简模式不支持 -->
        <n-form-item *ngIf="!isSimpleMode" [label]="i18n.selectedLab" [required]="true">
            <n-advanced #selectedFsToggle id="create-fs-snapshot-advance" [expand]="fsTableExpand"
                [title]="selectedFs.length" style="line-height: .32rem;">
            </n-advanced>
        </n-form-item>

        <n-form-item [class.hidden]="!isSimpleMode && (!selectedFsToggle || !selectedFsToggle.expand)"
            [labelHide]="true">
            <n-tip type="failed"
                *ngIf="!selectedFs.length && selectionChangeResult"
                [content]="i18n.emptyErr">
            </n-tip>
            <n-transfer-table id="cdp_create_fs_table"
                [leftTitle]="i18n.avaiableFsLab"
                [rightTitle]="i18n.selectedLab"
                [config]="tableConfig"
                [leftColumnDefs]="columnDefs"
                [rightColumnDefs]="columnDefs"
                [rest]="fsRest"
                [(selection)]="selectedFs"
                (selectionChange)="selectionChange()">
            </n-transfer-table>
        </n-form-item>
    </ng-container>

    <!-- 极简模式 源LUN放顶部 -->
    <ng-container *ngIf="isSimpleMode && selectType === SnapSourceSelectTypeE.Single">
        <div class="fs-icon-and-label" nTextTips>
            <!-- 图标 -->
            <svg class="icon">
                <use [attr.xlink:href]="'#app-icon-simple-file-system'"></use>
            </svg>
            <!-- Label -->
            <span class="fs-name-label">{{selectedFs.length > 0 ? selectedFs[0].NAME : UNPLACEHOLDER}}</span>
        </div>
    </ng-container>

    <ng-container *ngIf="showSchedule && showSnap">
        <!-- 请选择保护方式label -->
        <n-form-item [labelHide]="true">
            <div class="simple-step-title mt-40">
                <div class="step-number"><span>2</span></div>
                {{i18n.protectTypeLabel}}
            </div>
        </n-form-item>

        <!-- 快照保护模式类型：加入CDP策略 or 创建单次快照 -->
        <n-form-item [required]="true" [labelHide]="true">
            <n-radio-group formControlName="protectType" [cardStyle]="true" (onChange)="protectTypeChange($event)">
                <!-- 加入CDP策略 -->
                <n-radio id="create-fs-snap-protect-cdp-schedule-id" [value]="SnapProtectTypeE.CdpSchedule"
                    [icon]="'#app-icon-protection-s-snapshot-once'" [title]="i18n.addScheduleLabel"
                    [tip]="i18n.addScheduleCardTip" [ngStyle]="{'width': multiTitleWidth}">
                </n-radio>

                <!-- 创建单次快照 -->
                <n-radio id="create-fs-snap-protect-snap-id" [value]="SnapProtectTypeE.Snap"
                    [icon]="'#app-icon-protection-s-snapshot-policy'" [title]="i18n.singleSnapLabel"
                    [tip]="i18n.singleSnapCardTip" [ngStyle]="{'width': multiTitleWidth}">
                </n-radio>
            </n-radio-group>
        </n-form-item>
    </ng-container>

    <!-- 加入CDP策略。仅极简模式主页面支持 -->
    <n-form-item [labelHide]="true" [class.hidden]="vmValue.protectType !== SnapProtectTypeE.CdpSchedule">
        <div class="simple-step-title" [ngClass]="{'mt-40': showSnap}">
            <div class="step-number" *ngIf="showSchedule && showSnap"><span>3</span></div>
            {{i18n.selectScheduleLabel}}
        </div>
    </n-form-item>

    <n-form-item *ngIf="showSchedule" [labelHide]="true" [required]="true"
        [class.hidden]="vmValue.protectType !== SnapProtectTypeE.CdpSchedule">

        <!-- 添加策略按钮 -->
        <div class="table-operation interval-10 mt-16 mb-16">
            <n-button-group [items]="scheduleBtnGroup">
            </n-button-group>
        </div>

        <n-data-card #scheduleDataCard id="cdp-schedule-data-card" [config]="dataCardConfig" [multiCardStyle]="true"
            [multiCardWidth]="multiCardWidth" [supportSelectedFirstData]="true"
            [supportSelectedFirstData]="!modifySchedule" [defaultData]="scheduleDefaultData" [initSelectVal]="initSelectVal"
            [showDefaultWhenNoData]="true" [rest]="getBatchScheduleRest" formControlName="schedule">
        </n-data-card>
    </n-form-item>

    <!-- 极简模式下，快照参数放到高级设置-->
    <n-collapse-list *ngIf="isSimpleMode" [class.hidden]="vmValue.protectType !== SnapProtectTypeE.Snap"
        id="advance-setting-collapse" [title]="i18n.advancedSettingTitle" class="advance-setting-collapse">
        <ng-container [ngTemplateOutlet]="snapForm">
        </ng-container>
    </n-collapse-list>

    <ng-container *ngIf="!isSimpleMode" [ngTemplateOutlet]="snapForm">
    </ng-container>

    <!-- 快照相关参数表单 -->
    <ng-template #snapForm>
        <n-form-item [label]="i18n.sourceFS" *ngIf="!isSimpleMode && selectType === SnapSourceSelectTypeE.Single">
            {{selectedFs.length > 0 ? selectedFs[0].NAME : UNPLACEHOLDER}}
        </n-form-item>

        <n-form-item [label]="i18n.vStoreLab" *ngIf="selectType === SnapSourceSelectTypeE.Single && !isSimpleMode">
            <div>{{selectedFs.length > 0 ? selectedFs[0].vstoreName : UNPLACEHOLDER}}</div>
        </n-form-item>

        <n-form-item [label]="i18n.name" [class.hidden]="vmValue.protectType === SnapProtectTypeE.CdpSchedule"
            [helpContent]="!isCdp ? i18n.snapshotNameRuleTip : i18n.cdpNameRuleTip">
            <input type="text" id="create-filesystem-snapshot-name" nInput [placeholder]="placeholderName"
                formControlName="name">
        </n-form-item>

        <n-form-item [label]="i18n.descriptionLab"
            [class.hidden]="vmValue.protectType === SnapProtectTypeE.CdpSchedule">
            <textarea id="create-filesystem-snapshot-description" nTextarea [placeholder]="placeholderdescriptionLab"
                formControlName="description">
                </textarea>
        </n-form-item>

        <!-- 标签设置 -->
        <n-form-item [label]="i18n.snapshotTag"
            [helpContent]="i18n.snapshotTagTip"
            [class.hidden]="isSimpleMode || vmValue.protectType === SnapProtectTypeE.CdpSchedule">
            <input type="text" id="create-filesystem-snapshot-snapTag" nInput [placeholder]="placeholderSnapTag"
                formControlName="snapTag">
        </n-form-item>

        <!-- WORM开关与上面UCD要求有间距,方便视觉区分 -->
        <n-form-item [class.hidden]="isSimpleMode || vmValue.protectType === SnapProtectTypeE.CdpSchedule">
        </n-form-item>

        <!-- WORM开关 -->
        <n-form-item [label]="i18n.wormTab" class="wrom-switch"
            [class.hidden]="isSimpleMode || vmValue.protectType === SnapProtectTypeE.CdpSchedule">
            <n-switch formControlName="isSecuritySnap" id="file_cdp_create_wormenabled"
                (onChange)="wormEnabledChange($event)">
            </n-switch>
        </n-form-item>

        <ng-container *ngIf="vmValue.isSecuritySnap">
            <!-- 安全保护期 -->
            <n-form-item [label]="i18n.protectTime"
                [class.hidden]="vmValue.protectType === SnapProtectTypeE.CdpSchedule">
                <!-- 最小保护期 -->
                <n-spinner style="width:3rem" [onlyInput]="true" [precision]="0" [min]="protectPeriodMin"
                    [max]="protectPeriodMax" formControlName="expiredTime" id="file_cdp_create_protect_period">
                </n-spinner>
                <span class="ml-10">{{i18n.protectPeriodRangeLabel | fn :protectPeriodMin :protectPeriodMax}}</span>

                <!-- 最小保护期 单位-->
                <n-select style="width:1.2rem" class="ml-10" [options]="protectPeriodOptions"
                    formControlName="expiredTimeUnit" (onChange)="unitChanged($event)"
                    id="file_cdp_create_protect_period_unit">
                </n-select>
            </n-form-item>

            <!-- 自动删除 -->
            <n-form-item [label]="i18n.enableAutoDelete"
                [class.hidden]="vmValue.protectType === SnapProtectTypeE.CdpSchedule">
                <n-checkbox [label]="i18n.enableLab" id="file_cdp_create_auto_delete" formControlName="isAutoDelete">
                </n-checkbox>
                <p class="sub mt-10">{{i18n.autoDeleteInfo}}</p>
            </n-form-item>
        </ng-container>
    </ng-template>

</form>

<!-- 修改策略高危提示中的表格 -->
<ng-template #modifyScheduleTableTemplate>
    <n-data-table id="modify-fs-schedule-table" style="height: 2rem;" [columnDefs]="modifyScheduleTableColumnDefs"
        [data]="selectedFs">
    </n-data-table>
</ng-template>
